import React from 'react';

const MobileListSpinner: React.FC = () => (
  <div className="flex items-center justify-center p-4">
    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
    <span className="ml-2 text-gray-600">Loading ...</span>
  </div>
);

export default MobileListSpinner;
